(() => {
  if (window.etBrandStockStarted) return;
  window.etBrandStockStarted = true;
  const completed = new WeakSet();
  let timer;
  function cards(grid) { return Array.from(grid.children).filter(el => el.hasAttribute('data-et-product')); }
  async function run() {
    const grid = document.querySelector('[data-et-stock-grid]');
    if (!grid || completed.has(grid)) return;
    completed.add(grid);
    const original = cards(grid);
    const pages = Number(grid.dataset.etPages);
    const current = Number(grid.dataset.etPage);
    const size = Number(grid.dataset.etPageSize);
    const total = Number(grid.dataset.etTotal);
    const section = grid.dataset.id;
    const startUrl = location.href;
    grid.setAttribute('aria-busy', 'true');
    try {
      const buckets = new Array(pages);
      buckets[current - 1] = original;
      const pending = Array.from({length: pages}, (_, i) => i + 1).filter(p => p !== current);
      async function worker() {
        while (pending.length) {
          const page = pending.shift();
          const url = new URL(startUrl);
          url.searchParams.set('page', String(page));
          url.searchParams.set('section_id', section);
          const response = await fetch(url, {credentials: 'same-origin', signal: AbortSignal.timeout(15000)});
          if (!response.ok) throw new Error('Collection page unavailable');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const remote = doc.querySelector('[data-et-stock-grid]');
          if (!remote || Number(remote.dataset.etPage) !== page || Number(remote.dataset.etTotal) !== total) throw new Error('Collection changed');
          buckets[page - 1] = cards(remote);
        }
      }
      await Promise.all(Array.from({length: Math.min(3, pending.length)}, worker));
      if (!grid.isConnected || location.href !== startUrl) return;
      const all = buckets.flat();
      if (all.length !== total || new Set(all.map(el => el.dataset.etProduct)).size !== total) throw new Error('Incomplete collection');
      const available = all.filter(el => el.dataset.etAvailable === 'true');
      const soldOut = all.filter(el => el.dataset.etAvailable !== 'true');
      const selected = available.concat(soldOut).slice((current - 1) * size, current * size);
      selected.forEach(el => {
        el.classList.remove('scroll-trigger', 'animate--slide-in', 'scroll-trigger--offscreen');
        el.querySelectorAll('img').forEach(img => { img.loading = 'lazy'; });
      });
      grid.replaceChildren(...selected);
      grid.dataset.etStockSorted = 'true';
    } catch (error) {
      grid.dataset.etStockSorted = 'error';
      console.warn('Availability ordering could not finish.', error.message);
    } finally {
      grid.removeAttribute('aria-busy');
    }
  }
  new MutationObserver(() => { clearTimeout(timer); timer = setTimeout(run, 50); })
    .observe(document.getElementById('MainContent') || document.body, {childList: true, subtree: true});
  run();
})();
